import { useEffect, useState } from "react";

import throttle from "lodash.throttle";

export function useViewportDimensions(throttleDelay = 100) {
    const [viewportDimensions, setViewportDimensions] = useState({
        viewportWidth: 0,
        viewportHeight: 0,
        pageXOffset: 0,
        pageYOffset: 0
    });

    useEffect(() => {
        if (
            viewportDimensions.viewportWidth === 0 &&
            viewportDimensions.viewportHeight === 0
        ) {
            setViewportDimensions({
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight,
                pageXOffset: window.pageXOffset,
                pageYOffset: window.pageYOffset
            });
        }

        const resize = throttle(() => {
            setViewportDimensions({
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight,
                pageXOffset: window.pageXOffset,
                pageYOffset: window.pageYOffset
            });
        }, throttleDelay);

        window.addEventListener("resize", resize);

        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [viewportDimensions, setViewportDimensions, throttleDelay]);

    return viewportDimensions;
}
